// initial state
const state = {
  notificationAuthorized: false,
  remindTimeOriginal: [],
  cancelTimeOriginal: []
}

// getters
const getters = {
  notificationAuthorized: (state) => state.notificationAuthorized,
  remindTimeOriginal: (state) => state.remindTimeOriginal,
  cancelTimeOriginal: (state) => state.cancelTimeOriginal
}

// actions
const actions = {
  updateNotificationAuthorized() {
    window.uni.postMessage({
      data: {
        updateNotificationAuthorized: true
      }
    })
  },
  openAppAuthorizeSetting() {
    window.uni.postMessage({
      data: {
        openAppAuthorizeSetting: true
      }
    })
  }
}

const mutations = {
  SET_NOTIFICATION_AUTHORIZED(state, notificationAuthorized) {
    state.notificationAuthorized = notificationAuthorized
  },
  SET_REMIND_TIME_ORIGINAL(state, remindTimeOriginal) {
    state.remindTimeOriginal = remindTimeOriginal
  },
  SET_CANCEL_TIME_ORIGINAL(state, cancelTimeOriginal) {
    state.cancelTimeOriginal = cancelTimeOriginal
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
